import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { fetchOpeningFees } from "api/fetchers";

export default function useOpeningFees() {
    const { business, businessid } = useSelector((state) => state);
    const businessId = business?._id || businessid;

    const query = useQuery({
        queryKey: ["openingFees", businessId],
        queryFn: fetchOpeningFees,
    });

    const openingFees = Array.isArray(query.data) ? query.data : [];

    return {
        openingFees,
        ...query,
    };
}
